import { CircularProgress, Stack, StackProps, CircularProgressProps } from '@mui/material';

import { mergeSx } from '../../../utils/styles';

type CenteredSpinnerProps = Omit<StackProps, 'children'> & {
  size?: number;
  color?: CircularProgressProps['color'];
};

const CenteredSpinner = ({ size, color, ...stackProps }: CenteredSpinnerProps) => {
  return (
    <Stack
      {...stackProps}
      sx={mergeSx(
        {
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        },
        ...(Array.isArray(stackProps.sx) ? stackProps.sx : [stackProps.sx])
      )}
    >
      <CircularProgress size={size} color={color} />
    </Stack>
  );
};

export default CenteredSpinner;
